import { DataModel } from "common/models/utility-models/base-model";

export class FeedbackMappingModel extends DataModel {
    feedback_Form_Id: any = '';
    title: any = '';
    students: any[] = [];
    batch_id: any = '';

}